module.exports = __webpack_public_path__ + "img/pubgm-h-bg.d79be7e.png";